import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '@gasbuddy/react';
import { InfoBox, GoogleMap, LoadScriptNext } from '@react-google-maps/api';
// import { LoadScriptOnlyIfNeeded } from './load-script';
import { Loader } from '@gasbuddy/react-components';
import styles from './styles.css';
import { MapPosition } from '../../utils/prop-types/common-types';

const { getGoogleMapsAPIKey } = require('../../../lib/bputils').default;

class Map extends React.PureComponent {
  static propTypes = {
    // The children will be InfoBoxes
    children: PropTypes.node.isRequired,
    onMapInfoBoxPositionChange: PropTypes.func,
    editMode: PropTypes.bool,
    center: MapPosition.isRequired,
  };

  static defaultProps = {
    onMapInfoBoxPositionChange: null,
    editMode: false,
  };

  constructor(props) {
    super(props);

    this.state = this.mapPropsToState();
  }

  mapPropsToState = () => {
    const infoBox = this.props.children;

    return {
      infoBoxPosition: infoBox.props.position,
      center: this.props.center,
    };
  };

  componentDidUpdate = (prevProps) => {
    if (!_.isEqual(this.props.center, prevProps.center)
      || !_.isEqual(this.props.children.props.position,
        prevProps.children.props.position)
    ) {
      this.setState(() => ({ ...this.mapPropsToState() }));
    }
  };

  handleOnClick = (e) => {
    const { onMapInfoBoxPositionChange, editMode } = this.props;

    if (editMode) {
      const infoBoxPosition = { lat: e.latLng.lat(), lng: e.latLng.lng() };

      this.setState(() => ({ infoBoxPosition }));

      if (onMapInfoBoxPositionChange) {
        onMapInfoBoxPositionChange(infoBoxPosition);
      }
    }
  };

  render() {
    const { children: infoBox } = this.props;
    const { center, infoBoxPosition } = this.state;

    const defaultMapOptions = {
      fullscreenControl: false, // Hide fullscreen-view button
      streetViewControl: false, // Hide Street-view button
    };
    const mapAPIKey = getGoogleMapsAPIKey();
    /*
      position the triangle right on where marker should be
      the top left corner is where the marker should be
    */
    const triangleOffset = {
      width: -11, // half of the width of triangle
      height: -11, // height of triangle
    };
    const pinOffset = {
      width: -45, // half the width of the pin
      height: -74 + triangleOffset.height, // height of pin + height of triangle (because triangle is lower than the pin)
    };

    return (
      <LoadScriptNext
        googleMapsApiKey={mapAPIKey}
        loadingElement={<Loader className={styles.loader} />}
      >
        <GoogleMap
          mapContainerClassName={styles.mapContainer}
          zoom={17}
          center={center}
          options={defaultMapOptions}
          onClick={this.handleOnClick}
        >
          <InfoBox
            position={infoBoxPosition}
            options={{
              pixelOffset: pinOffset,
              closeBoxURL: '',
              enableEventPropagation: false,
              boxStyle: {
                overflow: 'hidden',
                width: '90px',
                'box-shadow': 'rgba(0, 0, 0, 0.33) 0px 8px 6px 3px',
                'border-radius': '8px',
              },
            }}
          >
            {infoBox}
          </InfoBox>
          <InfoBox
            position={infoBoxPosition}
            options={{
              pixelOffset: triangleOffset,
              closeBoxURL: '',
              enableEventPropagation: false,
              boxStyle: {
                width: '100px',
                top: '-6.5px !important',
              },
            }}
          >
            <div>
              <div className={styles.downTriangle} />
            </div>
          </InfoBox>
        </GoogleMap>
        {''}
      </LoadScriptNext>
    );
  }
}

const mapStateToProps = (state) => {
  const props = {
    id: state.station.id,
    center: {
      lat: state.station.latitude,
      lng: state.station.longitude,
    },
    brandings: state.station.brandings,
  };
  return props;
};

export default connect(mapStateToProps)(Map);
